"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Hero = ({
  title,
  backgroundColor,
  colorMode,
  typeface,
  backgroundImage,
  textColor,
  categoryTitle,
  categoryUrl,
  editorUrl,
  editor,
  company
}) => {
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.HeroContainer, {
    backgroundColor: backgroundColor,
    colorMode: colorMode
  }, _react.default.createElement(_styles.HeroTitle, {
    typeface: typeface
  }, title), _react.default.createElement(_styles.HeroBottomContainer, null, _react.default.createElement(_styles.HeroImage, {
    src: backgroundImage.src,
    color: textColor
  }), _react.default.createElement(_styles.HeroCreditsContainer, null, _react.default.createElement(_styles.HeroCreditsGroup, null, _react.default.createElement(_styles.HeroCredits, null, "(SPONSORED STORY)"), _react.default.createElement(_styles.HeroCredits, null, "Category: ", _react.default.createElement("a", {
    href: categoryUrl
  }, categoryTitle)), _react.default.createElement(_styles.HeroCredits, null, "Words by ", _react.default.createElement("a", {
    href: editorUrl
  }, editor)))))));
};
var _default = Hero;
exports.default = _default;
//# sourceMappingURL=Hero.js.map